var _path, _ellipse, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSchool4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M772 206L772 234",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 772.5,
    cy: 201.333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M772 210L765 206.2V200.2L761 198L772 192L783 198V206H781V199.1L779 200.2V206.2L772 210ZM772 201.7L778.85 198L772 194.3L765.15 198L772 201.7ZM772 207.725L777 205.025V201.25L772 204L767 201.25V205.025L772 207.725Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchool4);
export default __webpack_public_path__ + "static/media/school_4.3e6103df2de4950fa8eda10b2110989f.svg";
export { ForwardRef as ReactComponent };